<template>
    <div>
        <el-page-header @back="$router.go(-1)" content="短信发送测试"></el-page-header>
        <el-row>
            <el-col :span="12" :offset="3">
                <el-form :model="form" ref="form" label-width="100px">
                    <el-form-item label="Api账号">
                        <el-input v-model="form.user"></el-input>
                    </el-form-item>
                    <el-form-item label="密码">
                        <el-input v-model="form.pwd"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号">
                        <el-input v-model="form.mobile"></el-input>
                    </el-form-item>
                    <el-form-item label="短信内容">
                        <el-input v-model="form.msg"></el-input>
                    </el-form-item>
                    <el-form-item label="消息ID">
                        <el-input v-model="form.msgid"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: {
                    user: "",
                    pwd: "",
                    mobile: "",
                    msg: "",
                    msgid: "",
                },
                errors: {}
            }
        },
        methods: {
            submit() {
                this.$utils.post("/test/simple", this.form, (result) => {
                    this.$alert(result);
                });
            }
        }
    }
</script>